import { schoolApi } from '@/api/super-admin/school.api';

export const superAdminSchoolService = {
  getAllSchools: async (page = 1, size = 100) => {
    const data = await schoolApi.getAll(page, size);
    return { data };
  },

  getSchoolsByOrganization: async (organizationId) => {
    const data = await schoolApi.getAll(1, 100);
    const schools = data.items.filter((s) => s.organization_id === organizationId);
    return { data: { ...data, items: schools } };
  },

  getSchoolById: async (id) => {
    const data = await schoolApi.getById(id);
    return { data };
  },

  updateSchool: async (id, updates) => {
    const data = await schoolApi.update(id, updates);
    return { data };
  },

  createSchool: async (schoolData) => {
    const data = await schoolApi.create(schoolData);
    return { data };
  },

  createSchoolConfiguration: async (id, configData) => {
    const data = await schoolApi.createConfiguration(id, configData);
    return { data };
  },

  updateSchoolConfiguration: async (id, configData) => {
    const data = await schoolApi.updateConfiguration(id, configData);
    return { data };
  },

  getSchoolConfiguration: async (id) => {
    const data = await schoolApi.getConfiguration(id);
    return { data };
  },
};
